import React, {Fragment} from "react";
import {
    Alert,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    Pagination,
    Toolbar,
    Typography
} from "@mui/material";
import SnackError from "../../components/SnackError";
import {
    IntrApiGet,
    useDeleteInterruptByIdMutation,
    useGetInterruptQuery,
    usePutInterruptByIdMutation,
} from "./intr_api";

import Cancel from "@mui/icons-material/Cancel";
import Delete from "@mui/icons-material/Delete";
import DoNotDisturb from "@mui/icons-material/DoNotDisturb";
import Edit from "@mui/icons-material/Edit";
import {SearchBox} from "../../components/SearchBox";
import sortComparator from "../../libs/sortComparator";
import filterFunction from "../../libs/filterFunction";
import pager from "../../libs/pager";
import {Route, Routes, useHref} from "react-router-dom";
import {IntrCreate} from "./IntrCreate";
import {IntrEdit} from "./IntrEdit";
import SortBox from "../../components/SortBox";
import Title from "../navigation/Title";
import usePaginator from "../../hooks/usePaginator";
import {ListGrid} from "../../components/styled";

export type IntrItemProps = {
    onDelete: (id: number) => void,
    item: IntrApiGet,
    selectable?: boolean;
    onSelect?: (id: number) => void;
}

const IntrItem = (props: IntrItemProps) => {
    const {item, selectable, onSelect} = props;

    const path = useHref(`./${item.id}/edit`);

    const [put, {
        isLoading: isUpdating,
        error,
        isError,
    }] = usePutInterruptByIdMutation();

    if (!item) {
        return <Box>
            <Alert severity={"error"}>Object not found!</Alert>
        </Box>
    }

    return <Card sx={{
        minHeight: "150px",
        width: "100%",
    }} onClick={() => {
        selectable && onSelect && onSelect(item.id);
    }}>
        <CardContent>

            <Typography variant={"subtitle1"}> {item.Code} {item.Active === false && "Neaktiven"}</Typography>
            <Typography variant={"h6"}>{item.Name}</Typography>
            {item.Timeout && <Typography variant={"body2"}>Trajanje: {item.Timeout} minut</Typography>}

        </CardContent>
        {!selectable && <CardActions>
            <Button
                title={item.Active ? "Onemogoči" : "Omogoči"}
                sx={{
                    color: item.Active ? undefined : "error.main"
                }} onClick={() => {
                put({body: {Active: !item.Active}, id: item.id})
            }}>{!item.Active ? <Cancel/> : <DoNotDisturb/>}</Button>

            <Button href={path}
                    title={"Uredi prekinitev"}
            ><Edit fontSize={"small"}/></Button>

            <Button title="Briši prekinitev"
                    onClick={() => {
                        props.onDelete(item.id);
                    }}
            ><Delete fontSize={"small"}/> </Button>
        </CardActions>}

    </Card>
}


export type IntrListProps = {
    list: IntrApiGet[],
    selectable?: boolean;
    onSelect?: (id: number) => void;
}

export const IntrList = (props: IntrListProps) => {
    const {list, onSelect, selectable} = props;

    const [deleteIntr, {
        error: deleteIntrError
    }] = useDeleteInterruptByIdMutation();

    const handleDelete = (id: number) => {
        deleteIntr({id});
    }

    return <ListGrid>
        {deleteIntrError && <SnackError error={deleteIntrError}/>}
        {list.map(param => <IntrItem key={param.id} item={param}
                                     onSelect={onSelect}
                                     selectable={selectable}
                                     onDelete={handleDelete}/>)}
    </ListGrid>
}

type OpControllerProps = {
    pageSize?: number;
    selectable?: boolean;
    onSelect?: (id: number) => void;
}

const sortFields = {
    Name: "Naziv",
    Code: "Koda",
    Timeout: "Trajanje",
    Active: "Aktiven",
};


export const IntrListController = ({pageSize, selectable, onSelect}: OpControllerProps) => {

    const {
        filter,
        setFilter,
        page,
        setPage,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection
    } = usePaginator("interrupt", sortFields,)
    const path = useHref("./create");

    const {data, error, isFetching} = useGetInterruptQuery({});

    if (error) {
        return <SnackError error={error}/>;
    }
    if (isFetching || !data) {
        return <CircularProgress/>
    }

    const list: Array<IntrApiGet> = data && data.filter(filterFunction(filter, ["Name", "Code", "Active"]))
        .sort(sortComparator(sortDirection, sortField)) || [];
    const [pages, currentPage] = pager(list, page, pageSize);

    return <Fragment>
        <Toolbar sx={{display: "flex", "&.MuiToolbar-root": {p:0}, mb:1 ,justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap"}}>
            {!selectable && <Button href={path}>Dodaj prekinitev</Button>}
            <Box sx={{display: "flex", ml: "auto"}}>
                <SearchBox value={filter} onChange={setFilter}/>
                <SortBox sortDirection={sortDirection} sortField={sortField}
                         onChangeDirection={setSortDirection}
                         onSelectField={setSortField} fields={sortFields}
                />
            </Box>
        </Toolbar>

        <IntrList list={currentPage} selectable={selectable} onSelect={onSelect}/>
        <Pagination page={page} onChange={(e, page) => setPage(page)} count={pages}/>
    </Fragment>
}
export type IntrProps = {
    pageSize?: number
}

export default ({pageSize = 15}: IntrProps) => {


    return <Fragment>
        <Title title={"Vrste Prekinitev"}/>
        <Routes>
            <Route path={"/create"} element={<IntrCreate/>}/>
            <Route path={"/:id/edit"} element={<IntrEdit/>}/>
            <Route path={"/"} element={<IntrListController pageSize={pageSize}/>}/>
        </Routes>
    </Fragment>
}
